const getTotal = (array = [], field = null) => {
  if (array && array.length > 0) {
    if (field)
      return array.map(item => +item?.[field] || 0).reduce((a, b) => a + b)
    else return array.reduce((a, b) => a + b)
  } else return 0
}

export default getTotal
